<template>
  <!-- menuL3-->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="categoryId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
    <add ref='model'></add>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
import add from './add.vue';
export default {
  name: 'commissionSetLevel3',
  components: {
    add
  },
  data () {
    return {
      categoryId: undefined,
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '类目名称',
          props: ['categoryName']
        }
      ],
      tableOptList: [
        {
          text: '批量设置',
          icon: 'plus',
          permi: ['community:category:batchEdit'],
          handle: () => {
            this.$refs.model.show(this.categoryId, true);
          }
        }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => { this.$refs.model.show(row); },
          permi: ['community:category:edit']
        }
      ],
      columns: [{
        title: '类目名称',
        dataIndex: 'categoryName',
        align: '',
        width: '40%'
      },
      {
        title: '技术服务费比例',
        dataIndex: 'platformServicePoint',
        customCell: (row) => ({ domProps: { innerHTML: row.platformServicePoint + '%' }}),
        align: '',
        width: ''
      },
      {
        title: '分销佣金比例',
        dataIndex: 'commissionPoint',
        customCell: (row) => ({ domProps: { innerHTML: row.commissionPoint + '%' }}),
        align: '',
        width: ''
      },
      {
        title: '积分返还比例',
        dataIndex: 'pointsPoint',
        customCell: (row) => ({ domProps: { innerHTML: row.pointsPoint + '%' }}),
        align: '',
        width: ''
      },
      {
        title: '操作',
        dataIndex: 'action',
        align: '',
        width: '',
        scopedSlots: { customRender: 'action' }
      }
      ],
      dataSource: [],
      searchParams: {
        categoryName: undefined
      },
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {
    empty.$on('refreshCommissionList', () => {
      this.$refs.table.getTableList();
    });
    if (this.$route.query.categoryId) {
      this.categoryId = this.$route.query.categoryId;
      this.listApi.url = '/local/category/category3/list/' + this.categoryId;
    }
  },
  methods: {
    /** 弹窗详情 */
    modalDetail (row) {
      this.visible = true;
      this.rowData = row;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
